__webpack_require__.p = "//akita-fun.jp/packs/";